import axios from 'axios';
import { getAuthHeader } from '../utils/auth';

const API_URL = process.env.REACT_APP_API_URL + 'staff';

export const getStaff = async () => {
  const response = await axios.get(API_URL, { headers: getAuthHeader() });
  return response.data;
};

export const getStaffMember = async (id) => {
  const response = await axios.get(`${API_URL}/${id}`, { headers: getAuthHeader() });
  return response.data;
};

export const createStaffMember = async (staff) => {
  const response = await axios.post(API_URL, staff, { headers: getAuthHeader() });
  return response.data;
};

export const updateStaffMember = async (id, staff) => {
  const response = await axios.put(`${API_URL}/${id}`, staff, { headers: getAuthHeader() });
  return response.data;
};

export const deleteStaffMember = async (id) => {
  const response = await axios.delete(`${API_URL}/${id}`, { headers: getAuthHeader() });
  return response.data;
};

export const updateStaffStatus = async (id, status) => {
  const response = await axios.put(`${API_URL}/${id}/status`, status, { headers: getAuthHeader() });
  return response.data;
};

export const updateStaffLimits = async (id, limits) => {
  const response = await axios.put(`${API_URL}/${id}/limits`, limits, { headers: getAuthHeader() });
  return response.data;
};

export const resetStaffLimits = async (id) => {
  const response = await axios.post(`${API_URL}/${id}/limits/reset`, {}, { headers: getAuthHeader() });
  return response.data;
};
